
import { Component, Mixins } from "vue-property-decorator";
import { IInputRuleBehavior, InputRuleKinds } from "../../../../../../documaker/domain/format/objects";
import { IInputRuleBehaviorPropertyEditable, instanceOfIInputRuleBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class InputRuleBehaviorPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IInputRuleBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IInputRuleBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isInputRuleBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIInputRuleBehaviorPropertyEditable(s) && s.inputRuleBehavior().isEditable(), false);
  }

  get inputRuleBehavior(): IInputRuleBehavior {
    return this.readPropertyOrDefault(s => s.inputRuleBehavior().getValue(), { kind: InputRuleKinds.None });
  }

  set inputRuleBehavior(value: IInputRuleBehavior) {
    this.writePropertyWhenValid(s => s.inputRuleBehavior().setValue(value));
  }
}
